import { addBook } from "../action-types";

const addNewBook = (book) => {
  return async (dispatch) => {
    const responce = await fetch("http://localhost:9000/books", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(book),
    });

    const newBook = await responce.json();
    dispatch(addBook(newBook))
  };
};

export default addNewBook;